import { MessageModalsType } from "../types";
import { createAction } from "./create.action";

export namespace MessageModalsAction {

    export const showMessage = (message?: string, title?: string, icon?: string) => createAction(MessageModalsType.SET_MESSAGE_MODAL_DATA, { message, title, icon });
    export const hideMessage = () => createAction(MessageModalsType.CLEAR_MESSAGE_MODAL_DATA);

}